import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=ed4fce6e&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=ed4fce6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4fce6e",
  null
  
)

export default component.exports